import React from 'react';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';
import classNames from 'classnames';
import moment from 'moment';


const columnData = (statusCode, flag) => {
  return {
    logIdx: {
      colWidth: '50px',
      th: <th rowSpan={2}>No.</th>,
      td: (props) => {
        return <td>{props.index + 1}</td>;
      },
    },
    areaNo: {
      colWidth: '200px',
      th: <th>설비번호</th>,
      td: (props) => {
        return <td>{props.areaNo}</td>;
      },
    },
    areaNm: {
      colWidth: '300px',
      th: <th>설비명</th>,
      td: (props) => {
        return <td>{props.areaNm}</td>;
      },
    },
    modelNo: {
      colWidth: '300px',
      th: <th rowSpan={2}>감지기No.</th>,
      td: (props) => {
        return <td>{props.modelNm}</td>;
      },
    },
    o2: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          산소 <br /> O<sub>2</sub>(%)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames('data-text', props.o2_status)}>{props.o2.toFixed(1)}</td> : <td colSpan={props.gasCnt}>REPEATER</td>)
      },
    },
    h2s: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          황화수소 <br /> H<sub>2</sub>S(ppm)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.h2s_status)}>{props.h2s}</td> : <td>-</td> : <></>)
      },
    },
    co: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          일산화탄소 <br /> CO(ppm)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.co_status)}>{props.co}</td> : <td>-</td> : <></>)
      },
    },
    hc: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          {flag === "0" ? <>폭발성가스 <br /> CH4(%)</> : <>탄화수소 <br /> HC(%)</>}
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.hc_status)}>{props.hc}</td> : <td>-</td> : <></>)
      },
    },
    co2: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          이산화탄소 <br /> CO<sub>2</sub>(ppm)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames('data-text', props.co2_status)}>{props.co2}</td> : <></>)
      },
    },
    status: {
      colWidth: '130px',
      th: <th rowSpan={2}>상태</th>,
      td: (props) => {
        return (statusCode === '0' ? <td>{statusConverterForWhiteBackground(props.status)}</td> : <></>)
      },
    },
    battery: {
      colWidth: '130px',
      th: <th rowSpan={2}>Battery잔량</th>,
      td: (props) => {
        return <td>{Math.floor(props.battery)} %</td>;
      },
    },
    rgstDt: {
      colWidth: '400px',
      th: <th rowSpan={2}>측정시간</th>,
      td: (props) => {
        return <td>{props.rgstDt && moment(props.rgstDt).format('YYYY-MM-DD HH:mm:ss')}</td>;
      },
    },
  };
}

export default columnData;
